import React from "react"
import { Icon } from "@chakra-ui/core"
import { Button, ButtonProps } from "../Buttons"
import { bodyProps } from "../typography/Body"

type SelectedFilterButtonProps = ButtonProps & {}

export default function SelectedFilterButton({
  children,
  ...props
}: SelectedFilterButtonProps) {
  return (
    <Button
      h="2rem"
      pl="0.75rem"
      pr="0.5rem"
      py="0.4063rem"
      backgroundColor="sunrise"
      color="white"
      _hover={{
        backgroundColor: "sunriseLight20",
      }}
      _active={{
        backgroundColor: "sunriseLight7",
      }}
      {...bodyProps("xs")}
      fontWeight="500"
      textTransform="none"
      minWidth="0"
      boxShadow="none"
      {...props}
    >
      {children}
      <Icon name="x" fontSize="1.5rem" ml="0.125rem" />
    </Button>
  )
}
